'use client'

import GeneralForm from "components/GeneralForm";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { addError } from "components/validateGeneralForm";
import { validate } from "components/validateGeneralForm";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Container, FormGroup, Input } from "reactstrap";
import { erroInesperado } from "services/Utils";

const tipoAditivoList = [
  { value: 'R', label: 'Reajuste' },
  { value: 'M', label: 'Alteração Manual' },
]

export default function NovoAditivoPasso1() {
  const [data, setData] = useState({})
  const params = useParams()
  const navigate = useNavigate()

  const idContrato = parseInt(params.idContrato)

  const formConfig = useMemo(() => {
    const lst = [
      { name: "numero", label: 'Número', type: "text", required: true, colspan: 6 },
      { name: "inicioVigencia", label: 'Início da Vigência', type: "date", required: true, colspan: 6 },
      { name: "descricao", label: 'Descrição', type: "textarea", required: true, colspan: 12, style: { height: 130 } },
      { name: "tipo", label: 'Tipo de Aditivo', type: "combo", options: tipoAditivoList, showDefault: true, required: true, colspan: 4 },
    ]

    if (data.tipo == 'R')
      lst.push({ name: "percentual", label: 'Percentual', type: "decimal", required: true, colspan: 3 })

    return [lst]
  }, [data.tipo])

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)

    if (!errors.some(el => el.fieldName == 'inicioVigencia')) {
      const hoje = new Date()
      hoje.setHours(0, 0, 0, 0)

      if (data.inicioVigencia.getTime() <= hoje) {
        addError(errors, "inicioVigencia", "O início da vigência deve ser posterior a data atual")
      }
    }

    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    navigate(`/admin/contratos/${idContrato}/aditivos/novo/passo2`, { state: data })
  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Criar Aditivo - Dados Gerais" showButton={false} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
              disabled={false}
            />
            <Button type="submit" color="primary">Avançar</Button>
          </form>
        </CardBody>
      </Card>
    </Container>
  )
}